import PropTypes from 'prop-types'
import { useState, useEffect, useRef, useCallback } from 'react'
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { toastErrorLog } from '../../../helpers/toastErrorLog'
import { formatearFecha } from '../../helpers/helper'
import { withValidador } from '../../hoc/withValidador'
import Metadatos from '../../publicaciones/Metadatos'
import AgregarFotos from '../../publicar/AgregarFotos'
import DescripcionProducto from '../../publicar/DescripcionProducto'
import FechaPublicacion from '../../publicar/FechaPublicacion'
import IndicarEtiquetas from '../../publicar/IndicarEtiquetas'
import ListaDeVentas from '../../publicar/ListaDeVentas'
import Ofertas from '../../publicar/Ofertas'
import VentasEspeciales from '../../publicar/VentasEspeciales'
import { actualizar } from '../../servicios/publicacionesService'
import * as publicacionService from '../../servicios/publicacionesService'
import LinkButton from '../../ui/LinkButton'
import styles from './AdministrarPublicacion.module.css'
import Borde from './borde/Borde'
import CambioPrecio from './CambioPrecio'
import { getEsquema } from './esquema'
import Estado from './Estado'
import Exposicion from './Exposicion'

const MILISEGUNDOS_A_SEGUNDOS = 1000
const SEGUNDOS_A_MINUTOS = 60
const SUMA_MINUTOS = 5
const FECHA = 10
const ENVIO_GRATIS = 1
const RETIRA_COMPRADOR = 2
const ENVIO_A_CARGO_COMPRADOR = 3
const PASO = {
  PRINCIPIO: -1,
  VIGENCIA: 0,
  CAMBIO_PRECIO: 1,
  OFERTAS: 2,
  DESCRIPCION: 3,
  VENTAS_ESPECIALES: 4
}

const AdministrarPublicacion = (props) => {
  const navigate = useNavigate()

  const [errores, setErrores] = useState({})
  const [grabando, setGrabando] = useState(false)
  const [publicacion, setPublicacion] = useState(props.publicacion)
  const [idPublicacionEstado, setIdPublicacionEstado] = useState(
    props.publicacion.idPublicacionEstado
  )
  const [showModal, setShowModal] = useState(false)
  const [showModalMessage, setShowModalMessage] = useState('')
  const [paso, setPaso] = useState(PASO.PRINCIPIO)
  const vigenciaManualRef = useRef({
    desde: props.publicacion?.desde || '',
    hasta: props.publicacion?.hasta || ''
  })

  const pasoRefs = useRef({})
  const pasoRefSetters = useRef({})
  const ultimaActualizacion = useRef(publicacion)

  const getPasoElemento = useCallback((paso) => pasoRefs.current[paso] || null, [])

  const setPasoRef = useCallback((paso) => {
    if (!pasoRefSetters.current[paso]) {
      pasoRefSetters.current[paso] = (p) => {
        pasoRefs.current[paso] = p
      }
    }
    return pasoRefSetters.current[paso]
  }, [])

  const idVendedor = parseInt(localStorage.getItem('idUsuario'))
  const timeout =
    import.meta.env.VITE_EXPIRATION_TIME / SEGUNDOS_A_MINUTOS / MILISEGUNDOS_A_SEGUNDOS +
    SUMA_MINUTOS

  const handleClose = useCallback(() => {
    setShowModal(false)
    setPublicacion(props.publicacion)
  }, [props.publicacion])

  useEffect(() => {
    ultimaActualizacion.current = publicacion
  }, [publicacion])

  useEffect(() => {
    if (Object.keys(props.publicacion).length > 0) {
      setPublicacion(props.publicacion)
      const refInicio = getPasoElemento(PASO.PRINCIPIO)
      if (refInicio) {
        refInicio.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }
    }
    if (props.publicacion.idPublicacionEstado && !idPublicacionEstado) {
      setIdPublicacionEstado(props.publicacion.idPublicacionEstado)
    }

    if (!Number(props.publicacion.idListaVenta)) {
      vigenciaManualRef.current = {
        desde: props.publicacion.desde || '',
        hasta: props.publicacion.hasta || ''
      }
    }
  }, [props.publicacion, getPasoElemento])

  const handleListaVentaChange = (listaSeleccionada) => {
    setPublicacion((prevState) => {
      if (listaSeleccionada && Number(listaSeleccionada.value) > 0) {
        if (!Number(prevState.idListaVenta)) {
          vigenciaManualRef.current = {
            desde: prevState.desde,
            hasta: prevState.hasta
          }
        }

        return {
          ...prevState,
          desde: listaSeleccionada.vigenciaDesde || prevState.desde,
          hasta: listaSeleccionada.vigenciaHasta || prevState.hasta
        }
      }

      return {
        ...prevState,
        desde: vigenciaManualRef.current.desde || prevState.desde,
        hasta: vigenciaManualRef.current.hasta || prevState.hasta
      }
    })
  }

  const pasoValido = useCallback(
    (name, value) => {
      const datosActualizados = {
        ...ultimaActualizacion.current,
        [name]: value
      }
      const datosParaValidarBase =
        value === undefined ? ultimaActualizacion.current : datosActualizados
      const datosParaValidar = {
        ...datosParaValidarBase,
        tieneRetiro: datosParaValidarBase.mediosEnvios?.some(
          (m) => m.idMedioEnvio === RETIRA_COMPRADOR
        ),
        tieneEnvioGratis: datosParaValidarBase.mediosEnvios?.some(
          (m) => m.idMedioEnvio === ENVIO_GRATIS
        )
      }

      const erroresValidacion = props.Validador.validarDato(getEsquema(), datosParaValidar, name)

      const requiereListaEnvio = datosParaValidar.mediosEnvios?.some(
        (medio) => medio.idMedioEnvio === ENVIO_A_CARGO_COMPRADOR
      )
      const errorListaEnvio =
        requiereListaEnvio && !datosParaValidar.idListaEnvio && !datosParaValidar.nombreListaEnvio
          ? 'Debes seleccionar una lista de envío para "Envío a cargo del comprador".'
          : null

      setErrores((prev) => {
        const nuevos = { ...prev }

        if (!erroresValidacion || !erroresValidacion[name]) {
          delete nuevos[name]
        }

        if (!errorListaEnvio) {
          delete nuevos.idListaEnvio
        }

        return {
          ...nuevos,
          ...(erroresValidacion || {}),
          ...(errorListaEnvio ? { idListaEnvio: errorListaEnvio } : {})
        }
      })

      const hayErrores = Boolean(erroresValidacion) || Boolean(errorListaEnvio)
      return !hayErrores
    },
    [props.Validador]
  )

  const handleChangeState = (name, value, callBack) => {
    ultimaActualizacion.current = { ...ultimaActualizacion.current, [name]: value }
    setPublicacion((prevState) => ({
      ...prevState,
      [name]: value
    }))
    if (callBack) {
      callBack()
    }
  }

  const obtenerValor = useCallback((value, valueCalculado, checked, type, tipoDato) => {
    let val
    switch (tipoDato) {
      case 'bool':
        val = value === 'true'
        break
      case 'num':
        val = Number(value)
        break
      case 'calc':
        val = valueCalculado
        break
      default:
        val = type === 'checkbox' || type === 'radio' ? checked : value
        break
    }
    return val
  }, [])

  const handleChange = useCallback(
    ({ currentTarget: input } = {}, tipoDato = '', valueCalculado = null) => {
      if (!input) {
        return
      }
      const { name, value, checked, type } = input
      const valorEfectivo = obtenerValor(value, valueCalculado, checked, type, tipoDato)
      handleChangeState(name, valorEfectivo, () => {
        pasoValido(name, valorEfectivo)
      })
      if (name === 'idPublicacionEstado') {
        if (value === '2') {
          setShowModalMessage(
            `Publicaremos tu producto en la tienda virtual. Ten en cuenta que este proceso puede demorar como mínimo ${
              timeout
            } minutos, para que esté disponible a otros compradores.`
          )
          setIdPublicacionEstado(parseInt(value))
          setShowModal(true)
        }

        if (value === '3') {
          setShowModalMessage(
            `Estás a punto de pausar tu publicación. Si lo haces, otros compradores no podrán comprar esta publicación. Si más tarde deseas republicarla, ten en cuenta que el proceso puede demorar como mínimo ${
              timeout
            } minutos, para que esté disponible a otros compradores.`
          )
          setIdPublicacionEstado(parseInt(value))
          setShowModal(true)
        }

        if (value === '5') {
          setShowModalMessage(
            `Estás a punto de cambiar el estado de su publicación a vencida. Automaticamente se cambiara la fecha de vigencia hasta a la fecha actual. 
            Si lo haces, otros compradores no podrán comprar esta publicación.`
          )
          setIdPublicacionEstado(parseInt(value))
          setShowModal(true)
          handleChangeState('hasta', new Date().toISOString())
        }
      }
    },
    [pasoValido, handleChangeState, obtenerValor, timeout]
  )

  useEffect(() => {
    const refPaso = getPasoElemento(paso)
    if (refPaso) {
      refPaso.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
    }
  }, [paso, getPasoElemento])

  const validarForm = useCallback(async () => {
    const validacion = [
      { error: 'descripcion', paso: PASO.DESCRIPCION },
      { error: 'hasta', paso: PASO.VIGENCIA },
      { error: 'etiquetas', paso: PASO.ETIQUETAS },
      { error: 'precioUnitario', paso: PASO.CAMBIO_PRECIO },
      { error: 'alicuota', paso: PASO.CAMBIO_PRECIO },
      { error: 'cantDisponible', paso: PASO.CAMBIO_PRECIO },
      { error: 'preciosMayorista', paso: PASO.CAMBIO_PRECIO },
      { error: 'mediosPagos', paso: PASO.VENTAS_ESPECIALES },
      { error: 'mediosEnvios', paso: PASO.VENTAS_ESPECIALES },
      { error: 'cantDiasEnvioGratis', paso: PASO.VENTAS_ESPECIALES },
      { error: 'cantDiasRetiroComprador', paso: PASO.VENTAS_ESPECIALES },
      { error: 'descZona', paso: PASO.VENTAS_ESPECIALES },
      { error: 'descZonaRetiro', paso: PASO.VENTAS_ESPECIALES }
    ]

    try {
      const hayError = validacion.find(
        (campo) => !pasoValido(campo.error, publicacion[campo.error])
      )

      if (hayError) {
        setPaso(hayError.paso)
        return
      }

      setGrabando(true)
      const CAMPOS_OFERTA = ['porcDcto', 'ofertaDesde', 'ofertaHasta']
      const publicacionActualizada = {
        ...Object.fromEntries(
          Object.entries(publicacion).filter(([k]) => !CAMPOS_OFERTA.includes(k))
        ),
        desde: fechaDesdeFormateada,
        hasta: fechaHastaFormateada
      }

      await actualizar(publicacionActualizada).then(() => {
        setGrabando(false)
      })
      cancelarForm()
    } catch (error) {
      const mensaje = `Ocurrió un error al actualizar la publicación.`
      toastErrorLog(error, mensaje, 'publicaciones')
    }
  }, [pasoValido, publicacion, props, handleClose])

  const claseActivo = (posicion) => paso === posicion

  const cancelarForm = () => {
    navigate('/Publicaciones/Administrar')
  }

  const aplicarDescuento = async (descuento, desde, hasta) => {
    const camposOferta = [
      { error: 'porcDcto', value: descuento },
      { error: 'ofertaDesde', value: desde },
      { error: 'ofertaHasta', value: hasta }
    ]
    const hayErrorOferta = camposOferta.some(({ error, value }) => !pasoValido(error, value))
    if (hayErrorOferta) {
      setPaso(PASO.OFERTAS)
      return
    }
    setGrabando(true)
    try {
      await publicacionService.ActualizarPublicacionIndividual({
        IdPublicacion: publicacion.idPublicacion,
        PrecioUnitario: publicacion.precioUnitario,
        IdMoneda: publicacion.idMoneda,
        OfertaDesde: desde,
        OfertaHasta: hasta,
        porcDcto: descuento
      })
      toast.success('Descuento aplicado correctamente')
    } catch (error) {
      const mensaje = `Error al aplicar descuento.`
      toastErrorLog(error, mensaje, 'publicaciones')
    }
    setGrabando(false)
  }

  const borrarDescuento = async () => {
    setGrabando(true)
    try {
      await publicacionService.ActualizarPublicacionIndividual({
        IdPublicacion: publicacion.idPublicacion,
        PrecioUnitario: publicacion.precioUnitario,
        IdMoneda: publicacion.idMoneda,
        OfertaDesde: null,
        OfertaHasta: null,
        porcDcto: null
      })
      toast.success('Descuento eliminado correctamente')
    } catch (error) {
      const mensaje = `Error al eliminar descuento.`
      toastErrorLog(error, mensaje, 'publicaciones')
    }
    setGrabando(false)
  }

  const fechaDesdeFormateada = formatearFecha(publicacion.desde, 'ISO')
  const fechaHastaFormateada = formatearFecha(publicacion.hasta, 'ISO')

  return (
    <>
      <form className="container-general" onSubmit={(e) => e.preventDefault()}>
        <div className="row" ref={setPasoRef(PASO.PRINCIPIO)}>
          <div className="col-12">
            <p className="titulo-detalle">Publicación seleccionada</p>
            <div className="row">
              <div className="col-4">{publicacion.titulo}</div>
              <div className="col">
                {publicacion.monedaSimbolo}
                {publicacion.precioUnitario}
              </div>
              <div className="col">
                Vendidos:
                {publicacion.totalItemsPedidos}
              </div>
              <div className="col">{publicacion.publicacionEstado}</div>
              <div className="col">Exposición {publicacion.publicacionExposicion}</div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-4 borde-formulario">
              <Borde titulo="Exposición">
                <Exposicion
                  onChangeState={handleChangeState}
                  idExposicionAnterior={props.publicacion.idPublicacionExposicion}
                  idExposicionNueva={publicacion.idPublicacionExposicion}
                />
              </Borde>
            </div>
            <div className="col-sm-3 borde-formulario">
              <Borde
                titulo="Vigencia"
                error={errores.hasta}
                ref={setPasoRef(PASO.VIGENCIA)}
                activo={claseActivo(PASO.VIGENCIA)}
              >
                <FechaPublicacion
                  vieneDeAdministrar={true}
                  onChange={handleChange}
                  publicacion={publicacion}
                />
              </Borde>
            </div>
            <div className="col-sm-4 borde-formulario">
              <Borde titulo="Etiquetas">
                <IndicarEtiquetas
                  vieneDeAdministrar={true}
                  onChangeState={handleChangeState}
                  value={publicacion.etiquetas}
                />
              </Borde>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 borde-formulario">
              <Borde titulo="Incluir en Lista de Ventas">
                <ListaDeVentas
                  vieneDeAdministrar={true}
                  idVendedor={idVendedor}
                  onChange={handleChange}
                  onChangeState={handleChangeState}
                  onListaVentaChange={handleListaVentaChange}
                  value={publicacion.idListaVenta ? publicacion.idListaVenta : 0}
                  publicacion={publicacion}
                />
              </Borde>
            </div>
            <div className="col-sm-5 borde-formulario">
              <Borde
                titulo="Estado Publicaciones"
                error={errores.idPublicacionEstado}
                ref={setPasoRef(PASO.ESTADO)}
                activo={claseActivo(PASO.ESTADO)}
              >
                <Estado
                  onChange={handleChange}
                  value={publicacion.idPublicacionEstado}
                  vigenciaHasta={fechaHastaFormateada?.slice(0, FECHA)}
                />
              </Borde>
            </div>
          </div>
          <div className="row">
            {publicacion.precioUnitario !== 0 && !publicacion.conPresupuesto && (
              <>
                <div className="col-sm-6 borde-formulario">
                  <Borde
                    titulo="Cambio de Precio"
                    error={errores.cantDisponible || errores.precioUnitario || errores.alicuota}
                    ref={setPasoRef(PASO.CAMBIO_PRECIO)}
                    activo={claseActivo(PASO.CAMBIO_PRECIO)}
                  >
                    <CambioPrecio
                      idPublicacion={publicacion.idPublicacion}
                      onChangeState={handleChangeState}
                      value={publicacion.precioUnitario}
                      monedaSimbolo={publicacion.monedaSimbolo}
                      alicuota={publicacion.alicuota}
                      precioMayorista={publicacion.preciosMayorista}
                      isDisabled={false}
                      cantDisponible={publicacion.cantDisponible}
                      onChange={handleChange}
                    />
                  </Borde>
                </div>
                <div className="col-sm-5 borde-formulario">
                  <Borde
                    titulo="Oferta"
                    error={errores.porcDcto || errores.ofertaDesde || errores.ofertaHasta}
                    ref={setPasoRef(PASO.OFERTAS)}
                    activo={claseActivo(PASO.OFERTAS)}
                  >
                    <Ofertas
                      vieneDeAdministrar={true}
                      values={{
                        porcDcto: publicacion.porcDcto ?? props.publicacion.porcDcto ?? 0,
                        porcDctoPublicacion:
                          publicacion.porcDctoPublicacion ??
                          props.publicacion.porcDctoPublicacion ??
                          0,
                        porcDctoLista:
                          publicacion.porcDctoLista ?? props.publicacion.porcDctoLista ?? 0,
                        precioUnitario:
                          publicacion.precioUnitario ?? props.publicacion.precioUnitario ?? 0,
                        ofertaDesde: publicacion.ofertaDesde ?? props.publicacion.ofertaDesde ?? '',
                        ofertaHasta: publicacion.ofertaHasta ?? props.publicacion.ofertaHasta ?? '',
                        listaVigenciaDesde:
                          publicacion.listaVigenciaDesde ??
                          props.publicacion.listaVigenciaDesde ??
                          '',
                        listaVigenciaHasta:
                          publicacion.listaVigenciaHasta ??
                          props.publicacion.listaVigenciaHasta ??
                          '',
                        listaOfertaDesde:
                          publicacion.listaOfertaDesde ?? props.publicacion.listaOfertaDesde ?? '',
                        listaOfertaHasta:
                          publicacion.listaOfertaHasta ?? props.publicacion.listaOfertaHasta ?? ''
                      }}
                      onChange={handleChange}
                    />
                    <div className="mt-2 d-flex gap-2">
                      <button
                        type="button"
                        className="btn btn-success mr-2"
                        onClick={() =>
                          aplicarDescuento(
                            publicacion.porcDcto,
                            publicacion.ofertaDesde,
                            publicacion.ofertaHasta
                          )
                        }
                        disabled={
                          !publicacion.porcDcto ||
                          !publicacion.ofertaDesde ||
                          !publicacion.ofertaHasta
                        }
                      >
                        Aplicar descuento
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={borrarDescuento}
                        disabled={
                          publicacion.porcDctoPublicacion === 0 ||
                          publicacion.porcDctoPublicacion === null
                        }
                      >
                        Eliminar descuento
                      </button>
                    </div>
                  </Borde>
                </div>
              </>
            )}
          </div>
          <div className="row">
            <div className={`col-sm-6 borde-formulario `}>
              <Borde
                titulo="Escribí la descripción de tu producto"
                error={errores.descripcion}
                ref={setPasoRef(PASO.DESCRIPCION)}
                activo={claseActivo(PASO.DESCRIPCION)}
              >
                <DescripcionProducto onChange={handleChange} value={publicacion.descripcion} />
              </Borde>
            </div>
            <div className="col-sm-5 borde-formulario">
              <Borde titulo="Características del Producto">
                <Metadatos idPublicacion={publicacion.idPublicacion} editable={true} />
              </Borde>
            </div>
          </div>
        </div>
        <div className="row">
          <div className={`col-sm-6 borde-formulario `}>
            <Borde titulo="Fotografías">
              <AgregarFotos
                value={publicacion.youtube || ''}
                vieneDeAdministrar={true}
                onChange={handleChange}
                idPublicacion={publicacion.idPublicacion}
                idPublicacionTemporal={0}
              />
            </Borde>
          </div>
          <div className="col-sm-5 borde-formulario">
            <Borde
              titulo="Método de Pago y Envío"
              ref={setPasoRef(PASO.VENTAS_ESPECIALES)}
              activo={claseActivo(PASO.VENTAS_ESPECIALES)}
              error={
                errores.mediosPagos ||
                errores.mediosEnvios ||
                errores.idListaEnvio ||
                errores.cantDiasEnvioGratis ||
                errores.cantDiasRetiroComprador ||
                errores.descZona ||
                errores.descZonaRetiro
              }
            >
              <VentasEspeciales
                vieneDeAdministrar={true}
                idPublicacion={publicacion.idPublicacion}
                values={{
                  extensionGarantia: publicacion.extensionGarantia,
                  garantias: publicacion.garantias,
                  mediosPagos: publicacion.mediosPagos,
                  mediosEnvios: publicacion.mediosEnvios,
                  envioGratis: publicacion.envioGratis,
                  descZona: publicacion.descZona,
                  descZonaRetiro: publicacion.descZonaRetiro,
                  cantDiasEnvioGratis: publicacion.cantDiasEnvioGratis,
                  cantDiasRetiroComprador: publicacion.cantDiasRetiroComprador,
                  idListaEnvio: publicacion.idListaEnvio,
                  nombreListaEnvio: publicacion.nombreListaEnvio
                }}
                onChange={handleChange}
              />
            </Borde>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col">
            <div className="col d-flex justify-content-end">
              <LinkButton className="btn btn-volver-comprar w-50" onClick={validarForm}>
                {grabando ? (
                  <span>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="mr-2"
                    />
                    Guardando...
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-check mr-2" aria-hidden="true" />
                    Aceptar
                  </span>
                )}
              </LinkButton>
            </div>
          </div>
          <div className="col">
            <LinkButton className="btn btn-reclamar w-50" onClick={cancelarForm}>
              <i className="fa fa-times mr-2" aria-hidden="true" />
              Cancelar
            </LinkButton>
          </div>
        </div>
      </form>
      <Modal show={showModal} onHide={handleClose} size={'lg'} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>Estado publicación</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{showModalMessage}</Modal.Body>
        <Modal.Footer>
          <div className={styles.modalFooterButtons}>
            <button type="button" className="btn btn-enviar" onClick={handleClose}>
              Cancelar
            </button>
            <button type="submit" className="btn btn-volver-comprar" onClick={validarForm}>
              Aceptar
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

AdministrarPublicacion.propTypes = {
  publicacion: PropTypes.shape({
    idPublicacionEstado: PropTypes.number.isRequired,
    cantDisponible: PropTypes.number.isRequired,
    idPublicacionExposicion: PropTypes.number.isRequired,
    idPublicacion: PropTypes.number.isRequired,
    titulo: PropTypes.string.isRequired,
    monedaSimbolo: PropTypes.string.isRequired,
    precioUnitario: PropTypes.number.isRequired,
    totalItemsPedidos: PropTypes.number.isRequired,
    publicacionEstado: PropTypes.string.isRequired,
    publicacionExposicion: PropTypes.string.isRequired,
    desde: PropTypes.string,
    hasta: PropTypes.string,
    etiquetas: PropTypes.string,
    idListaVenta: PropTypes.number,
    descripcion: PropTypes.string,
    youtube: PropTypes.string,
    extensionGarantia: PropTypes.number,
    garantias: PropTypes.array,
    mediosPagos: PropTypes.array,
    mediosEnvios: PropTypes.array,
    envioGratis: PropTypes.bool,
    porcDcto: PropTypes.number,
    porcDctoPublicacion: PropTypes.number,
    porcDctoLista: PropTypes.number,
    listaVigenciaDesde: PropTypes.string,
    listaVigenciaHasta: PropTypes.string,
    listaOfertaDesde: PropTypes.string,
    listaOfertaHasta: PropTypes.string,
    ofertaDesde: PropTypes.string,
    ofertaHasta: PropTypes.string,
    alicuota: PropTypes.number
  }).isRequired,
  idPublicacion: PropTypes.number.isRequired,
  setPublicacion: PropTypes.func.isRequired,
  Validador: PropTypes.shape({
    validarDato: PropTypes.func.isRequired
  }).isRequired
}

export default withValidador(AdministrarPublicacion)
